import { useContext } from 'react';
import './FinalizationFailedPage.scss';
import errorImg from '../../img/graphic-design/SomethingWentWrong.svg';
import PageTitle from '../../components/PageTitle/PageTitle';
import Strings from '../../localization/strings';
import HeaderButtons from '../../components/PageBase/Header/HeaderButtons';
import { FinalizationContext } from '../../providers/FinalizationProvider/FinalizationProvider';
import { PrimaryButton } from '@fluentui/react';
import LocalizationHelper from '../../localization/LocalizationHelper';

const FinalizationFailedPage = () => {
    const myStrings = Strings.finalizationFailed;
    const { finalization } = useContext(FinalizationContext);

    let title = myStrings.title;
    let subtitle = myStrings.subtitle;

    const hostingCreationErrorInfo = finalization?.selectDataExternally(x => x.hostingCreationErrorInfo);
    if (hostingCreationErrorInfo) {
        title = myStrings.titleDuplicateEmailRequest;
        subtitle = myStrings.subtitleDuplicateEmailRequest;
    }

    const czMailTo = "mailto:support@eway-crm.com?subject=Registrace%20se%20nezda%C5%99ila&body=Dobr%C3%BD%20den%2C%0D%0A%0D%0ASna%C5%BE%C3%ADm%20se%20ud%C4%9Blat%20si%20%C3%BA%C4%8Det%20do%20eWay-CRM%2C%20ale%20nepovedlo%20se%20mi%20to.%20Pros%C3%ADm%20o%20pomoc.%0D%0A%0D%0AS%20pozdravem%2C";
    const enMailTo = "mailto:support@eway-crm.com?subject=Sign%20Up%20Failed&body=Hello%2C%0D%0A%0D%0AI%20am%20trying%20to%20create%20an%20account%20with%20eWay-CRM%2C%20but%20it%20failed.%0D%0A%0D%0ARegards%2C";
    const mailTo = LocalizationHelper.isLanguageCs() ? czMailTo : enMailTo;

    return (
        <div className="background-gradient">
            <HeaderButtons />
            <div className="finalization-failed-page">
                <img src={errorImg} alt="error" className="finalization-failed-page__img" />
                <div className="finalization-failed-page__title">
                    <PageTitle title={title} subtitle={subtitle} variant={'medium'} />
                </div>

                    <a href={mailTo}>
                <PrimaryButton text={myStrings.contactSupport} className="finalization-failed-page__button" />
                    </a>
            </div>
        </div>
    );
};

export default FinalizationFailedPage;
